<script>
    import { getContext, setContext } from "svelte";
    let joueur = getContext("joueur");
    $: skills = joueur.skills;
    console.log(joueur);
</script>

<div id="block">
    <div id="imgfond">
        <img src="img/skills.png" alt="skills" />
    </div>

    <div id="blockspell" />
    {#each skills as sort, i}
        <img class="spell" src="img/spell1.png" alt="" />
        <img id="imgfondspell" src="img/spell.png" alt="" />
    {/each}
</div>

<style>
    @font-face {
        font-family: "scifi";
        src: url("/conthrax-sb.ttf");
    }
    #imgfond {
        top: 90%;
        left: 50%;
        transform: translate(-50%, -50%);
        position: absolute;
    }
    img {
        z-index: 2;
    }
    p {
        background-color: chartreuse;
        z-index: 2;
        position: relative;
        width: 70px;
        height: 65px;

        border: solid 1px black;

        margin-right: 12px;
    }
    #divspell {
        position: absolute;
        top: 90%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 592px;
        height: 124px;
        display: grid;
        grid-template-columns: 70px 70px 70px 70px 70px 70px 70px;
        grid-template-rows: 65px;
        background-color: rgba(100, 148, 237, 0.37);
        border: solid 1px black;
        overflow: hidden;
    }
    #blockspell {
        width: 592px;
        height: 124px;
        position: absolute;
        top: 90%;
        left: 50%;
        transform: translate(-50%, -50%);
        display: flex;
        background-color: blueviolet;
    }
    #block {
        display: flex;
        flex-direction: row;
    }
    #imgfondspell {
        position: relative;
        width: 70px;
        height: 65px;
        margin: 5px;
    }
    #blockimgspell {
        position: absolute;
        z-index: 3;
        display: flex;
        top: 0%;
    }
    .spell {
        position: relative;
        z-index: 3;
        left: 75px;
        top: 5px;
        width: 70px;
        height: 65px;
    }
</style>
